import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../../-LazyRoutePage"

const SalesOrderPage = lazy(
  () => import("../../../../../components/WMS/SalesOrders/SalesOrderPage.tsx"),
)

export const Route = createFileRoute(
  "/_layout/WMS/documents/sales-orders/$salesOrder",
)({
  component: SalesOrderRoute,
  validateSearch: (search: {
    tab?: unknown
    mode?: unknown
  }): { tab?: "general" | "info" | "files"; mode?: "edit" } => ({
    ...(search.tab === "info" ||
    search.tab === "files" ||
    search.tab === "general"
      ? { tab: search.tab }
      : {}),
    ...(search.mode === "edit" ? { mode: "edit" } : {}),
  }),
})

function SalesOrderRoute() {
  return (
    <LazyRoutePage>
      <SalesOrderPage />
    </LazyRoutePage>
  )
}
